<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" @show="onShow" :title="computedTitle"
                   @hidden="onHidden" :show-confirmation="showConfirmation" @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12" v-if="sale && sale.dates">
          <input-widget :model="model" attribute="auction_date_uuid"
                        display-field="${item.title}" type="select2"
                        :items="sale.dates"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import BatchSessionUpdateModel from "@/modules/lots/batch-session-update-modal/BatchSessionUpdateModel.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import LotsService from "@/modules/lots/LotsService";
  import {SOURCE_LOTS_TABLE} from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('lots');

  export default {
    name: "BatchSessionUpdateModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new BatchSessionUpdateModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.batchSessionUpdateModal,
        reservations: state => state.batchSessionUpdateModal.reservations,
        sale: state => state.batchSessionUpdateModal.sale,
      }),
      computedTitle() {
        return this.$i18n.t("Batch Session Update")
      }
    },
    methods: {
      ...mapActions(['hideBatchSessionUpdateModal', 'getTableData']),
      onShow() {
        this.showConfirmation = true;
        this.model = new BatchSessionUpdateModel();
      },
      onHidden() {
        this.hideBatchSessionUpdateModal();
      },
      async onSubmit() {
        let requestData = {
          auction_date_uuid: this.model.auction_date_uuid,
          auction_uuid: this.sale.uuid,
          lot_uuids: this.reservations.map(r => r.lot.uuid)
        }

        this.showConfirmation = false
        let response = await LotsService.batchUpdateLotSession(requestData)
        if (response.success) {
          if (this.modal.source === SOURCE_LOTS_TABLE) {
            this.$toast('success', this.$i18n.t("Session for lot(s) was successfully updated"))
            this.getTableData()
            this.hideBatchSessionUpdateModal()
          }
        } else {
          this.showConfirmation = true
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
